import { DataBean } from "../DataBean";


export class FunctionalArea extends DataBean {

    public async getFunctionalAreaCatalog(state: number, name: string, idLnFunctionalID: number, idAppointment: number, contractState: number, idAccount: number, page: number, recordsPerPage: number): Promise<any> {
        return this.getCustomService(
            "QuickDataERPCore",
            "com.advantage.shared.Report_getFunctionalAreaCatalog_Number_String_Number_Number_Number_Number_Number_Number",
            [state, name, idLnFunctionalID, idAppointment, contractState, idAccount, page, recordsPerPage]
        );
    }

    public async getFunctionalAreaCatalogvdos(idLn: any, state: any, name: any, idLnFunctionalID: number, idAppointment: number, contractState: number, idAccount: number, date: any, page: number, recordsPerPage: number): Promise<any> {
        return this.getCustomService(
            "QuickDataERPCore",
            "com.advantage.shared.Report_getFunctionalAreaCatalog_Number_Number_String_Number_Number_Number_Number_java.util.Date_Number_Number",
            [idLn, state, name, idLnFunctionalID, idAppointment, contractState, idAccount, date, page, recordsPerPage]
        );
    }
    public async getFunctionalAreaCatalogDate(state: number, name: string, idLnFunctionalID: number, idAppointment: number, contractState: number, idAccount: number, date: any, page: number, recordsPerPage: number): Promise<any> {
        return this.getCustomService(
            "QuickDataERPCore",
            "com.advantage.shared.Report_getFunctionalAreaCatalog_Number_String_Number_Number_Number_Number_java.util.Date_Number_Number",
            [state, name, idLnFunctionalID, idAppointment, contractState, idAccount, date, page, recordsPerPage]
        );
    }

    public async getFunctionalAreaStateConstants(arg: null): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getFunctionalAreaStateConstants_Number", [arg]);
    }

    public async getFunctionalArea(idLn: number): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "admin.FunctionalArea_getFunctionalArea_Number", [idLn]);
    }

    public async getFunctionalAreaByIDAccount(idAccount: number): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getFunctionalAreaByIDAccount_Number", [idAccount]);
    }

    public async getFunctionalIDWorkMenber(idAccount: number): Promise<any> {
        return this.getCustomService("CacheOptions", "java.util.List_getFunctionalIDWorkMenber_Number", [idAccount]);
    }

    public async updateFunctionalArea(bean: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "admin.FunctionalArea_updateFunctionalArea_admin.FunctionalArea",
            [
                {
                    "DataBeanProperties": bean,
                    "DataBeanName": "admin.FunctionalArea"
                }
            ]
        );
    }
}